import { flow, } from "mobx"
import { TraxisCpeIdMixin, getCpeId } from "store/api/mixin/TraxisCpeIdMixin"
// MTVW-585: 1 retry
import { serviceUrls } from "store/qlapi/ServiceUrls"
import { appFeatures } from "AppFeatures"
import { getQlHeaders } from "store/qlapi/QlHeaders"
import { rootStore } from "store/RootStore"
import { timeNow, sleep } from "utils/Utils"
import { appStats, getStage, appVersion } from "utils/TestSupport"
//import { firstInstallStore } from "store/FirstInstallStore"
//import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import { setLanguage as setLang } from "store/lang/L10n"

import { getCoCoModule, wasmToPlainObject } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()

const STD_HEADERS = {
	'Accept': 'application/json',
	/*
	'pragma': 'no-cache', 'cache-control': 'no-cache',
	*/
}
export class LoginService extends TraxisCpeIdMixin {

	get xHeaders() {
		// make a copy of STD_HEADERS, otherwise STD_HEADERS would be changed!
		const headers = {}
		Object.assign(headers, STD_HEADERS)
		Object.assign(headers, getQlHeaders())
		return headers
	}

	version = flow(function* () {
		let resultJson = yield CoCo.apiFetchLoginVersionRaw()
		// CoCo returns string instead of object, need to convert to object
		if (typeof resultJson === "string") resultJson = JSON.parse(resultJson)
		return `${resultJson["build_tag"]} (${resultJson["build_date"]})`
	})

	// No retry, otherwise potential error will take too long
	authenticateAsync = flow(function* (user, pw, keepSignedIn, reAuth = false) {
		// MTVW-1031: reset error before authentication
		rootStore.page.Player.error = null
		// CoCo: Since the cookie is shared, we authenticate with CoCo
		try {
			// MTVW-516: workaround to avoid CoCo panic
			//if (appFeatures.bookmarksEnabled && rootStore.sso.browserStore.profileChange) yield sleep(500)
			rootStore.sso.browserStore.setProfileChange(null)
			// TODO!!!: CASE WITH UNDEFINED CpeId
			// in case of reAuth, user and pw are null
			//CoCo.initializeWithBasicAuth(this.xHeaders['X-Quickline-Deviceid'], user, pw)
			console.debug("auth reAuth %s, %s, cpeId", reAuth, this.xHeaders['X-Quickline-Deviceid'], getCpeId())
			//CoCo.initialize(this.xHeaders['X-Quickline-Deviceid'] ?? getCpeId(), false)
			const options = new CoCo.InitializeOptions(
				this.xHeaders['X-Quickline-Deviceid'] ?? getCpeId(),
				CoCo.DeviceType.Web,
				false
			)
			options.releaseTrack = getStage(true)
			options.version = appVersion()
			CoCo.initializeWithOptions(options)
			// MTVW-1105: set deviceId in CoCo although it's already provided in initialize
			CoCo.setDeviceID(this.xHeaders['X-Quickline-Deviceid'] ?? getCpeId())
			// MTVW-1153: disable for now
			//CoCo.setAppID(this.xHeaders['X-Quickline-App'])
			CoCo.setLanguage(appFeatures.locale)
			appStats.coco = "v" + CoCo.version()
			console.debug("CoCo %s", appStats.coco)
			//if (reAuth && keepSignedIn) console.warn("CoCo unsupported reAuth %s, keepSignedIn %s", reAuth, keepSignedIn)

			console.debug("autenticateUntrusted keepSignedIn %s, reAuth %s, user %s, pw %s", keepSignedIn, reAuth, user, pw)
			let authResult = null
			let authResultRaw = null
			let authResultTyped = null
			// Auth example using CoCo
			if (!reAuth) {
				//console.warn("path for !reAuth  user %s, pw %s", user, pw)
				authResultRaw = yield CoCo.authenticateUntrustedRaw(user, pw)
				authResultTyped = yield CoCo.authenticateUntrusted(user, pw)
			}
			else {
				//console.warn("path2 for BDD tests  user %s, pw %s", user, pw)
				authResultRaw = yield CoCo.reauthenticateUntrustedRaw()
				authResultTyped = yield CoCo.reauthenticateUntrusted()
			}
			if (typeof authResultRaw === "string") authResultRaw = JSON.parse(authResultRaw)
			let settings = authResultTyped.getSettingsRaw()
			if (typeof settings === "string") settings = JSON.parse(settings)
			authResultTyped = wasmToPlainObject(authResultTyped)
			// add settings
			authResultTyped.settings = settings
			// SELECT authResult to be used
			authResult = authResultTyped
			console.debug("CoCo authResult %o, %o", authResultRaw, authResultTyped/*,authResultTyped.getChannelLists()*/)
			serviceUrls.setUrls(authResult.serviceUrls)
			return authResult
		}
		catch (err) {
			console.error("CoCo authenticateUntrusted %o", err)
			// MTVW-1031: logoff could be potentially disabled, since it will create another 401 (not authenticated)
			yield this.logoff()
		}
		return authResult
	})

	loginAsync = flow(function* (profileId, pin = "") {
		// MTVW-1031: reset error before login
		rootStore.page.Player.error = null
		// MTVW-920: spinner off for error case
		rootStore.setIsLoading(false)
		let loginResult = null
		try {
			let loginUntyped = yield CoCo.loginRaw(profileId, pin)
			if (typeof loginUntyped === "string") loginUntyped = JSON.parse(loginUntyped)
			let loginTyped = yield CoCo.login(profileId, pin)
			// convert to plain object so that Object.assign can be used
			loginTyped = wasmToPlainObject(loginTyped)
			// MTVW-920: spinner on after successful login
			rootStore.setIsLoading(true)
			// SELECT loginResult to be used
			loginResult = loginTyped
			console.debug("CoCo login %o, %o", loginUntyped, loginTyped)
			// MTVW-540
			appFeatures.setGt12EnabledState(loginResult.gt12Enabled)
			CoCo.setLanguage(appFeatures.persistedLanguage)
			setLang(appFeatures.persistedLanguage)
		}
		catch (err) {
			console.error("CoCo login 1 %o", err)
			// throw error to show message (e.g. invalid PIN)
			throw (err)
		}

		try {
			if (loginResult) {
				CoCo.setLoggerMaxLevel(CoCo.LogLevel.Error)
				if (appFeatures.bookmarksEnabled) CoCo.setFeatureFlagEnabled(CoCo.FeatureFlag.BookmarksMsEnabled, true)
				rootStore.adsService.setAdsMockstate(appFeatures.persistedAdsMock)
				//CoCo.setFeatureFlagEnabled(CoCo.FeatureFlag.CaipyChannelsEnabled, false)
				CoCo.setFeatureFlagEnabled(CoCo.FeatureFlag.DetailsRecommendationsEnabled, true)
				CoCo.setFeatureFlagEnabled(CoCo.FeatureFlag.LangQueryParamEnabled, true)
				CoCo.setFeatureFlagEnabled(CoCo.FeatureFlag.LocalizedGenresEnabled, true)
				console.debug("CoCo bookmarksUrl", CoCo.getClientBaseUrl("bookmarks"))
				//CoCo.setClientBaseUrl("bookmarks", "https://sg1-bookmarks.qltv.quickline.ch/bookmarks/")
				// bookmarks version in appStats will be set in CoCoBookmarks?.init()
				// initialize, important after a profile change
				/* MTVW-1000: moved to App.completeInit
				if (false) {
					yield rootStore.page.CoCoBookmarks.init()
					yield rootStore.page.CoCoDiscover.init()
				}
				*/
			}
			//rootStore.waitForTimeSync.setResolve()
			const profileChange = rootStore.sso.browserStore.profileChange
			if (profileChange) {
				// MTVW-1032: update currentProfileId
				if (profileChange !== "profileRemoved") rootStore.sso.browserStore.setCurrentProfileId(profileChange)
				rootStore.sso.browserStore.setProfileChange(null)
				// MTVW-1063, MTVW-1066: initalize here for profileChange
				yield rootStore.page.CoCoBookmarks.init()
				yield rootStore.page.CoCoDiscover.init()
				// MTVW-1013
				yield rootStore.channelsService.init()
				rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
			}
			//console.debug("currentProfileId", profileChange, rootStore.sso.browserStore.currentProfileId)
			/* MTVW-1058: WOULD NOT WORK during firstInstall, moved to App.completeInit
			if (!firstInstallStore.isFirstInstall) {
				yield rootStore.page.CoCoBookmarks.init()
				yield rootStore.page.CoCoDiscover.init()
				// MTVW-1013
				yield rootStore.channelsService.init()
				rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
			}
			*/
			// MTVW-1094
			rootStore.sso.browserStore.setCurrentProfileId(profileId)
			appFeatures.applyPersistentSettings()
			// make sure channels are fetched and channel list is applied upon profile change,
			// no yield to prevent flicker during profile change
			rootStore.channelsService.init()
			setLang(appFeatures.persistedLanguage)
			rootStore.setIsLoading(false)
		}
		catch (err) {
			console.error("CoCo login 2 %o", err)
			// throw error to show message (e.g. invalid PIN)
			throw (err)
		}
		return loginResult
	})

	// MTVW-1095: use CoCo
	getProfileAsync = flow(function* (profileId, retryCount) {
		try {
			let profileRaw = yield CoCo.apiFetchProfileRaw(profileId)
			if (typeof profileRaw === "string")
			profileRaw = JSON.parse(profileRaw)
			const profileTyped = yield CoCo.fetchProfile(profileId, CoCo.FetchStrategy.NetworkOnly)
			// MTVW-1095: keep name returned from MS
			if (profileTyped.hasOwnProperty("personalizedRecommendations")) {
				profileTyped.personalizedRecommendationsEnabled = profileTyped.personalizedRecommendations
			}
			console.debug("getProfileAsync profile %o, %o", profileRaw, profileTyped)
			return profileTyped
		}
		catch (err) {
			console.error("getProfileAsync error %o", err)
			throw (err)
		}
	})

	// No retry, otherwise potential PIN error will take too long
	updateProfileAsync = flow(function* (profileId, props = {}, pin = "") {
		try {
			const updateProfile = new CoCo.LoginV002UpdateProfile(null, pin)
			Object.assign(updateProfile, props)
			console.debug("updateProfileAsync profileId %s, props %o, pin %s, updateProfile %o", profileId, props, pin, updateProfile)
			yield CoCo.apiUpdateProfile(pin, updateProfile)
		}
		catch (err) {
			console.error("updateProfileAsync error %o", err)
			throw (err)
		}
	})

	deleteProfileAsync = flow(function* (profileId, pin = "") {
		const result = yield CoCo.deleteProfile(/*profileId,*/ pin)
		return result
	})

	createProfileAsync = flow(function* (props = {}, pin = "") {
		const newProfile = new CoCo.LoginV002NewProfile(props.name, props.pinCode)
		newProfile.isAdultContentAccessShown = false
		newProfile.isFirstInstallationDone = props.isFirstInstallationDone
		newProfile.isLoginPinProtected = props.isLoginPinProtected
		newProfile.personalizedRecommendationsEnabled = props.personalizedRecommendationsEnabled
		const result = yield CoCo.createProfile(pin, newProfile)
		return result
	})

	getLoginProfilesAsync = flow(function* () {
		let profilesRaw = yield CoCo.apiFetchLoginProfilesRaw()
		if (typeof profilesRaw === "string") profilesRaw = JSON.parse(profilesRaw)
		let profilesTyped = yield CoCo.fetchProfiles(CoCo.FetchStrategy.NetworkOnly)
		profilesTyped = wasmToPlainObject(profilesTyped)
		// MTVW-1095: keep name returned from MS
		for (let i = 0; i < profilesTyped.length; i++)
			if (profilesTyped[i].hasOwnProperty("isLoginPinProtected")) {
				profilesTyped[i].isLoginPinProtectionEnabled = profilesTyped[i].isLoginPinProtected
			}
		console.debug("getLoginProfilesAsync %o, %o", profilesRaw, profilesTyped)
		return profilesTyped
	})

	// current token expirations
	// profileToken: 60 minutes
	// PurchaseToken: 10 minutes
	// TODO: expiration times from API
	get profileTokenRefreshInterval() {
		// safe value of 50 minutes
		return 50 * 60
	}

	// CoCo v0.18.3400: OK
	getMainUserContactInfoAsync = flow(function* () {
		const info = yield CoCo.fetchMainUserContactInfo(CoCo.FetchStrategy.NetworkOnly)
		// convert to plain object so that we can use Object.assign
		const result = wasmToPlainObject(info)
		console.debug("getMainUserContactInfoAsync", result)
		return result
	})

	getContractInfo = flow(function* () {
		const result = yield CoCo.apiFetchContractInfo()
		console.debug("getContractInfo", result)
		return result
	})

	refreshTokens = flow(function* () {
		let refreshResult = yield CoCo.apiRefreshTokens()
		if (typeof refreshResult === "string") refreshResult = JSON.parse(refreshResult)
		console.debug("refreshTokens", refreshResult)
		return refreshResult
	})

	logoff = flow(function* () {
		// what does CoCo.logout?
		yield CoCo.logoff()
		return
	})

	// MTVW-435
	resetPinAsync = flow(function* (profileId, contactType) {
		let result = yield CoCo.apiResetPin(profileId, contactType)
		if (typeof result === "string") result = JSON.parse(result)
		console.debug("resetPinAsync result %o, %o", result, contactType)
		return result
	})
}
